<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <h5 class="mb-0">{{ directT('ecommerce.orderDetails.orderSummary') }}</h5>
      </div>
    </div>

    <div class="trezo-card-content">
      <div class="table-responsive overflow-x-auto">
        <table class="w-full">
          <thead class="text-black dark:text-white">
            <tr>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md"
              >
                {{ directT('ecommerce.orderDetails.description') || "Description" }}
              </th>
              <th
                class="font-medium ltr:text-right rtl:text-left px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap first:rounded-tl-md"
              >
                {{ directT('ecommerce.orderDetails.price') || "Price" }}
              </th>
            </tr>
          </thead>
          <tbody class="text-black dark:text-white">
            <tr>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.grandTotal') }}
              </td>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ formatPrice(order?.totalamount) }}
              </td>
            </tr>
            <tr>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.discount') }}
              </td>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ hasDiscount ? '-' : '' }}{{ formatPrice(order?.discount) }}
              </td>
            </tr>
            <tr>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.tax') }}
              </td>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ formatPrice(order?.tax) }}
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.subtotal') }}
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ formatPrice(calculateSubtotal) }}
              </td>
            </tr>
            <tr>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.shippingCharge') }}
              </td>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ formatPrice(order?.shipping_charge) }}
              </td>
            </tr>
            <tr v-if="order?.couponsdiscount">
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.couponCharge') }}
              </td>
              <td
                class="text-gray-500 dark:text-gray-400 ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                -{{ formatPrice(order?.couponsdiscount) }}
              </td>
            </tr>
            <tr>
              <td
                class="font-medium ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ directT('ecommerce.orderDetails.total') }}
              </td>
              <td
                class="font-medium ltr:text-right rtl:text-left whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l"
              >
                {{ formatPrice(order?.total) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <h6 class="mt-[20px] md:mt-[25px] mb-[10px]">{{ directT('ecommerce.orderDetails.paymentMethod') }}</h6>
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <img src="@/assets/images/master-card.png" alt="master-card" />
          <div class="ltr:ml-[12px] rtl:mr-[12px]">
            <span class="block text-black dark:text-white font-medium">
              {{ directT('ecommerce.orderDetails.payment') }}
            </span>
            <span class="block text-sm mt-[3px]"> 
              {{ order?.payment_method || directT('ecommerce.orderDetails.viaMasterCard') }} 
            </span>
          </div>
        </div>
        <span class="block"> {{ formatPrice(order?.total) }} </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from "vue";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";
import { Order } from "@/services/orderService";

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

export default defineComponent({
  name: "OrderSummary",
  props: {
    order: {
      type: Object as PropType<Order | null>,
      required: true
    }
  },
  setup(props) {
    // i18n setup
    const { locale } = useI18n();
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };
    
    // Computed properties
    const hasDiscount = computed(() => {
      return props.order?.discount && parseFloat(String(props.order.discount)) > 0;
    });
    
    const calculateSubtotal = computed(() => {
      if (!props.order) return 0;
      
      // Start with total amount
      let subtotal = parseFloat(String(props.order.totalamount || 0));
      
      // Subtract discount
      if (props.order.discount) {
        subtotal -= parseFloat(String(props.order.discount));
      }
      
      // Add tax
      if (props.order.tax) {
        subtotal += parseFloat(String(props.order.tax));
      }
      
      return subtotal;
    });
    
    // Format price
    const formatPrice = (price: any): string => {
      if (price === undefined || price === null) return '$0.00';
      
      const numPrice = parseFloat(String(price));
      
      if (isNaN(numPrice)) return '$0.00';
      
      return locale.value === 'he' || locale.value === 'ar'
        ? `₪${numPrice.toFixed(2)}`
        : `$${numPrice.toFixed(2)}`;
    };
    
    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    return {
      directT,
      formatPrice,
      hasDiscount,
      calculateSubtotal
    };
  }
});
</script>
